export default __webpack_public_path__ + "static/media/LogInBgImage.57d0e3ec.png";